import isValid from 'date-fns/isValid';
import format from 'date-fns/format';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { Locale } from 'date-fns';
import React from 'react';
import { formatDateShort } from './date';

export const makeDateCellRenderer =
  (locale?: string): any =>
  ({ getValue }: any) => {
    const date = new Date(getValue());

    return isValid(date) ? formatDateShort(date, locale) : '-';
  };

export const makeRelativeDateCellRenderer =
  (locale?: Locale): any =>
  ({ getValue }: any) => {
    const date = new Date(getValue());
    if (!isValid(date)) return '-';
    const full = format(date, 'dd/MM/yyyy HH:mm');
    const relative = formatDistanceToNow(date, { addSuffix: true, locale });
    return (
      <span title={full} style={{ cursor: 'default' }}>
        {relative}
      </span>
    );
  };
